(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var top = document.querySelector('.top');
  var btn = document.querySelector('.menu-btn');
  if (btn && top) {
    btn.addEventListener('click', function () {
      var open = top.getAttribute('data-open') === 'true';
      top.setAttribute('data-open', String(!open));
      btn.setAttribute('aria-expanded', String(!open));
      btn.textContent = open ? 'MENU' : 'CLOSE';
    });
  }

  // CountUp (ported from design handoff motion.jsx): markup ships the final
  // accented HTML; animation swaps in plain digits, then restores the markup.
  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    if (RM) return;
    var target = parseFloat(el.dataset.count);
    if (isNaN(target)) return;
    var dec = parseInt(el.dataset.dec || '0', 10);
    var finalHtml = el.innerHTML;
    var start = performance.now(), dur = 1200;
    function fmt(n) {
      return n.toLocaleString('en-AU', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }
    function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(target * eased);
      if (t < 1) requestAnimationFrame(step);
      else el.innerHTML = finalHtml;
    }
    requestAnimationFrame(step);
  }

  var revealables = document.querySelectorAll('.rv, [data-draw]');
  function markIn(el) {
    el.classList.add('in');
    el.querySelectorAll('[data-count]').forEach(countUp);
    if (el.hasAttribute('data-count')) countUp(el);
  }
  if ('IntersectionObserver' in window && !RM) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { markIn(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add('in'); });
  }
  // Reliability fallback: never leave content hidden if observation misses
  setTimeout(function () {
    document.querySelectorAll('.rv:not(.in), [data-draw]:not(.in)').forEach(markIn);
  }, 1500);

  function initBooking(widget) {
    if (widget.dataset.ready) return;
    widget.dataset.ready = '1';
    var api = (widget.dataset.apiUrl || '').replace(/\/$/, '');
    var status = widget.querySelector('[data-booking-status]');
    var daysEl = widget.querySelector('[data-booking-days]');
    var form = widget.querySelector('[data-booking-form]');
    var slotInput = widget.querySelector('[data-booking-slot]');
    var confirm = widget.querySelector('[data-booking-confirm]');
    var selectedButton = null;
    if (!api || !status || !daysEl || !form || !slotInput || !confirm) return;

    function setStatus(text, tone) {
      status.textContent = text;
      status.dataset.tone = tone || '';
      status.hidden = !text;
    }
    function groupSlots(slots) {
      return slots.reduce(function (acc, slot) {
        var key = slot.day || 'Soon';
        if (!acc[key]) acc[key] = [];
        acc[key].push(slot);
        return acc;
      }, {});
    }
    function choose(btn, slot) {
      if (selectedButton) selectedButton.classList.remove('is-selected');
      selectedButton = btn;
      selectedButton.classList.add('is-selected');
      slotInput.value = slot.slot_start;
      form.hidden = false;
      setStatus('Selected ' + slot.day + ' at ' + slot.time + '.', '');
    }
    function render(slots) {
      daysEl.innerHTML = '';
      if (!slots.length) {
        setStatus('No clean slots in the next fortnight. Send the note and I will come back with a time.', 'warn');
        return;
      }
      var grouped = groupSlots(slots);
      Object.keys(grouped).slice(0, 5).forEach(function (day) {
        var col = document.createElement('div');
        col.className = 'sft-booking-day';
        var h = document.createElement('h3');
        h.textContent = day;
        col.appendChild(h);
        grouped[day].slice(0, 8).forEach(function (slot) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sft-booking-chip';
          btn.textContent = slot.time;
          btn.addEventListener('click', function () { choose(btn, slot); });
          col.appendChild(btn);
        });
        daysEl.appendChild(col);
      });
      daysEl.hidden = false;
      setStatus('Choose a slot.', '');
    }
    fetch(api + '/slots', { headers: { accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('slots');
        return r.json();
      })
      .then(function (data) { render(data.slots || []); })
      .catch(function () {
        setStatus('The live calendar is not reachable right now. Use the form and I will reply with times.', 'warn');
      });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!slotInput.value) {
        setStatus('Pick a slot first.', 'warn');
        return;
      }
      var payload = {
        slot_start: slotInput.value,
        name: form.elements.name.value,
        email: form.elements.email.value,
        brand: form.elements.brand.value,
        note: form.elements.note.value,
        website: form.elements.website.value
      };
      setStatus('Locking it in...', '');
      fetch(api + '/book', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.status === 409) throw new Error('taken');
          if (!r.ok) throw new Error('book');
          return r.json();
        })
        .then(function () {
          form.hidden = true;
          daysEl.hidden = true;
          setStatus('', '');
          confirm.hidden = false;
          if (window.gtag) window.gtag('event', 'booking_complete');
          if (window.fbq) window.fbq('trackCustom', 'BookingComplete');
        })
        .catch(function (err) {
          if (err.message === 'taken') {
            setStatus('That slot just went. Pick another clean one.', 'warn');
          } else {
            setStatus('Booking did not complete. Send the form and I will reply with times.', 'warn');
          }
        });
    });
  }

  document.querySelectorAll('[data-sft-booking]').forEach(initBooking);
})();
